import { DeliveryProvider, OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  text: {
    status: {
      [OrderFulfillmentStatus.Rejected]: 'Tem a certeza?',
    },
    [OrderMethod.Pickup]: 'O cliente já levantou a encomenda?',
    [OrderMethod.OnSite]: 'O cliente já levantou a encomenda?',
    [OrderMethod.Delivery]: {
      [DeliveryProvider.Standalone]: 'A encomenda já foi entregue?',
      [DeliveryProvider.UberDrive]: 'O estafeta já levantou a encomenda?',
      [DeliveryProvider.FirstDelivery]: 'O estafeta já levantou a encomenda?',
      [DeliveryProvider.WoltDrive]: 'O estafeta já levantou a encomenda?',
    },
  },
  buttons: {
    cancel: 'Não, Cancelar',
    confirm: 'Sim',
  },
};
